export const en = {
    'long-upload-accept-link': 'OK',
    'long-upload-message-addition': 'Upon completion, the video extension will be created automatically.',
    'long-upload-message-creative': 'When finished, the video creative will be created automatically.',
    'long-upload-message-end': 'Please do not close this window.',
    'long-upload-message-start': 'Please wait as the video is still processing.'
};
